<template>
  <i class="fa-solid fa-file text-gray-500"></i>
</template>
